import React from "react";
import PropTypes from "prop-types";
import { isMobile, isTablet, isIOS, isAndroid } from "react-device-detect";
import { has, get } from 'lodash';

const QuestionOption = ({ option = {}, onClick = f => f, processPhoto = f => f }) => {
    let label = option.label;
    let buttonClasses = "w3-button w3-block w3-round-xxlarge w3-large";

    if (has(option, "desktopLabel") && !isMobile && !isTablet && !isIOS && !isAndroid) {
        label = get(option, "desktopLabel");
    }

    if (get(option, "actionState.retakePhoto", false)) {
        buttonClasses = "w3-button w3-round-xxlarge w3-large";
    }

    buttonClasses += " " + get(option, "buttonColorClass", "w3-indigo");

    return (
        <div className="questionOption">
            <button id={option.itemID} className={buttonClasses} onClick={evt => onClick()}>
                {label}
            </button>
        </div>
    );
};

QuestionOption.propTypes = {
    option: PropTypes.object,
    onClick: PropTypes.func,
    processPhoto: PropTypes.func
};

export default QuestionOption;
